module.exports = __webpack_public_path__ + "assets/img/project-blob-right.f81474dd.webp";